import { render, staticRenderFns } from "./test_loy.vue?vue&type=template&id=84e4c968&scoped=true"
import script from "./test_loy.vue?vue&type=script&lang=js"
export * from "./test_loy.vue?vue&type=script&lang=js"
import style0 from "./test_loy.vue?vue&type=style&index=0&id=84e4c968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e4c968",
  null
  
)

export default component.exports